import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { WithChildren } from '../../_metronic/helpers'
import { usePermission } from '../modules/auth/core/usePermission'

type Props = {
  allOf?: string[]
  anyOf?: string[]
  // For admin/role management pages — a hard role check, not a permission,
  // matching the backend's requireSuperAdmin (a Custom role must never be
  // grantable the ability to manage roles or grant itself more access).
  superAdminOnly?: boolean
}

// Route guard: hides a page from an admin who lacks the permission, same
// idea as the sidebar filtering. This is UX only — the server is the real
// gate (see callgenie-backend's requirePermission / requireSuperAdmin).
export const RequirePermission: FC<Props & WithChildren> = ({
  allOf,
  anyOf,
  superAdminOnly,
  children,
}) => {
  const { hasPermission, hasAnyPermission, isSuperAdmin } = usePermission()
  const ok = superAdminOnly
    ? isSuperAdmin
    : allOf
    ? hasPermission(...allOf)
    : anyOf
    ? hasAnyPermission(...anyOf)
    : true
  return ok ? <>{children}</> : <Navigate to='/error/404' />
}
